<script>
  import {onMount} from 'svelte';
  let { item } = $props();
  onMount(async() => {
    refreshFsLightbox();
  });

</script>

{#if item && item.preview_image}

<div class="preview-image">
  <a href='{item.preview_image.url}' data-fslightbox="roll" class="preview"><img src={item.preview_image.url_thumb} alt="" /></a>
</div>

{/if}
